export default __webpack_public_path__ + "static/media/icn_products.4195150a.svg";